<template>
  <transition @enter="enter" @leave="leave" :css="false">
    <div class="transition-wrapper" v-if="appear">
      <div class="landing-block">
        <div class="landing-block__inner">
          <h1 ref="heading">{{ microContent["landing-page-title"] }}</h1>
          <div
            @click="routeTo('/scenarios')"
            aria-role="link"
            class="landing-block__inner-link"
          >
            <div class="landing-block__inner-box">
              <svg
                viewBox="0 0 462 424"
                class="landing-block__inner-box-border"
              >
                <g
                  id="Desktop-option-2"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="landing-block-border"
                    transform="translate(1.000000, 1.000000)"
                    stroke="#FF0030"
                    stroke-width="2"
                  >
                    <path
                      ref="borderRight"
                      d="M230,0 C261.478285,0 309.39539,0 373.751314,0 C421.3048,0 460.002628,38.7283393 460.002628,86.3193178 L460.002628,239.772667 C460.002628,287.361015 421.3048,326.089355 373.751314,326.089355 L327.0232,326.089355 C311.4016,326.089355 296.721028,333.723483 287.770742,346.555764 L237.859428,417.91461 C236.058857,420.463704 233.125371,422 230,422"
                    ></path>
                    <path
                      ref="borderLeft"
                      d="M-0.00263,0 C31.4756558,0 79.3927606,0 143.748684,0 C191.30217,0 229.999999,38.7283393 229.999999,86.3193178 L229.999999,239.772667 C229.999999,287.361015 191.30217,326.089355 143.748684,326.089355 L97.02057,326.089355 C81.39897,326.089355 66.7183986,333.723483 57.7681129,346.555764 L7.85679857,417.91461 C6.05622714,420.463704 3.12274143,422 -0.00263,422"
                      transform="translate(114.998684, 211.000000) scale(-1, 1) translate(-114.998684, -211.000000)"
                    ></path>
                  </g>
                </g>
              </svg>

              <p
                class="landing-block__inner-description text__content--lg"
                ref="context"
              >
                {{ microContent["landing-page-intro"] }}
              </p>
            </div>

            <button class="landing-block__next" ref="continueBtn">
              <img src="@/assets/imgs/bhf_next.svg" alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import animejs from "animejs";

export default {
  name: "LandingPage",
  computed: {
    ...mapGetters({
      microContent: "getMicroContent"
    })
  },
  beforeRouteEnter(to, from, next) {
    let animationName;
    if (from.name !== "scenarios") {
      animationName = "initialAnimation";
    } else {
      animationName = "returnAnimation";
    }
    next(vm => {
      vm.animationName = animationName;
      vm.appear = true;
    });
  },
  data: function() {
    return {
      appear: false,
      animationName: false
    };
  },
  mounted() {
    let event;
    if (typeof Event === "function") {
      event = new Event("render-event");
    } else {
      //IE fallback for dispatchEvent
      event = document.createEvent("Event");
      event.initEvent("render-event", true, true);
    }
    document.dispatchEvent(event);
  },
  methods: {
    routeTo: function(route) {
      this.$router.push(route);
    },
    //Animations
    enter: function(el, done) {
      const {
        heading,
        borderRight,
        borderLeft,
        context,
        continueBtn
      } = this.$refs;

      let tl = animejs.timeline({});

      if (this.animationName === "initialAnimation") {
        tl.add({
          targets: heading,
          translateY: [-100, 0],
          duration: 1000
        })
          .add(
            {
              targets: [borderLeft, borderRight],
              strokeDashoffset: [animejs.setDashoffset, 0],
              easing: "linear",
              duration: 1500
            },
            "0"
          )
          .add(
            {
              targets: context,
              opacity: [0, 1],
              duration: 1000
            },
            "-=1000"
          )
          .add({
            targets: continueBtn,
            scale: [1, 1.3],
            opacity: [0, 1],
            duration: 1000
          })
          .add(
            {
              targets: continueBtn,
              scale: [1.3, 1],
              duration: 1000
            },
            "-=1000"
          );
      } else {
        tl.add({
          targets: el,
          translateY: ["-150%", 0],
          opacity: [0, 1],
          duration: 1000,
          easing: "easeOutCubic"
        });
      }

      tl.finished.then(done);
    },
    leave: (el, done) => {
      let tl = animejs.timeline({});

      tl.add({
        targets: el,
        translateY: [0, "-200%"],
        opacity: [1, 0],
        duration: 1000,
        easing: "easeInCubic"
      });

      tl.finished.then(done);
    },
    //Prefetch Data
    preFetchCategoryStore(store) {
      if (Object.keys(store.state.ScenarioStore.scenariosData).length > 0)
        return;
      return store.dispatch(`fetchScenarios`);
    },
    preFetchMicroContentStore(store) {
      if (Object.keys(store.state.MicroContentStore.microContent).length > 0)
        return;
      return store.dispatch(`FetchMicroContent`);
    },
    ...mapGetters(["getMicroContent"])
  }
};
</script>

<style lang="scss" scoped>
.transition-wrapper {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.landing-block {
  width: 100%;
  max-width: 900px;
  padding: 1rem;
  margin: 0 auto;

  &__inner {
    position: relative;
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    @include media-breakpoint("md") {
      max-width: 500px;
    }

    &-box {
      position: relative;
      width: 100%;

      &-border {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 100%;
        height: 100%;
        margin-top: 1rem;

        @include media-breakpoint("md") {
          margin-top: 2rem;
        }
      }
    }

    &-link {
      cursor: pointer;
      -ms-touch-action: manipulation; /* IE10  */
      touch-action: manipulation; /* IE11+ */
    }

    &-description {
      position: relative;
      text-align: center;
      padding: 4rem 3rem 5rem;
      margin: 1rem 0;

      @include media-breakpoint("md") {
        padding: 7rem 5rem;
        margin: 1rem;
      }
    }
  }

  &__next {
    padding: 2rem 0 0 0;
    width: 100%;
    text-align: center;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    cursor: pointer;

    @at-root {
      button#{&} {
        width: 100%;
        -ms-touch-action: manipulation; /* IE10  */
        touch-action: manipulation; /* IE11+ */
      }
    }

    @include media-breakpoint("md") {
      padding: 4rem 0 0 0;
    }
  }
}
</style>
